"use strict";

import angular from "angular";

/**
 * Abre um formulário num painel lateral, com o mesmo contrato do `DesnuDialogService.custom`.
 *
 * Existe para os formulários longos -- adicionar/editar contabilidade -- que num diálogo
 * centralizado ficam espremidos. O contrato é igual de propósito: `controller`, `locals`,
 * `templateHtml` e `after.hide/cancel` são os mesmos, então um formulário troca de casa
 * mudando só a chamada, sem tocar no controller nem no template.
 *
 * Quem fecha o painel é o próprio conteúdo, pelo `$mdDialog` que recebe injetado -- uma
 * fachada com `hide` e `cancel` apontando para cá. É o que deixa `$ctrl.$mdDialog.cancel()`
 * continuar funcionando nos templates que vieram do diálogo.
 */
export class DesnuSidenavFormService {
    componentId = "DesnuSidenavForm";
    config = null;

    constructor($mdSidenav) {
        this.$mdSidenav = $mdSidenav;
        this.dialogFacade = {
            hide: (answer) => this.hide(answer),
            cancel: () => this.cancel()
        };
    }

    /**
     * `token` muda a cada abertura: é o que faz o componente montar conteúdo novo mesmo
     * quando o formulário aberto é o mesmo de antes, com outra contabilidade.
     */
    open({
        controller,
        controllerAs = "$ctrl",
        locals = {},
        templateHtml,
        title,
        width = "720px",
        after = {}
    } = {}) {
        if (!controller || !templateHtml) return false;

        this.config = {
            controller,
            controllerAs,
            locals: { ...locals, title, width },
            templateHtml,
            title,
            width,
            after,
            token: `${controller}-${Date.now()}`
        };

        this.$mdSidenav(this.componentId).open();
        return true;
    }

    hide(answer) {
        this._close("hide", answer);
    }

    cancel() {
        this._close("cancel");
    }

    close() {
        this.cancel();
    }

    /**
     * A configuração só é descartada quando a animação de saída termina: é ela que mantém o
     * formulário montado, e zerá-la na hora fazia o painel deslizar para fora vazio.
     *
     * O `token` é conferido no fim porque o painel pode ter sido reaberto no meio da
     * animação -- aí quem manda é a configuração nova, não a que está saindo.
     */
    _close(type, answer) {
        const config = this.config;
        if (!config) return;

        const clear = () => {
            if (this.config?.token === config.token) this.config = null;
        };

        // `then(clear, clear)`, e não `finally`: o `close()` rejeita quando o painel não está
        // registrado, e uma rejeição sem tratamento vira ruído no console.
        this.$mdSidenav(this.componentId).close().then(clear, clear);

        const after = config.after || {};
        if (type === "hide" && after.hide) after.hide(answer);
        if (type === "cancel" && after.cancel) after.cancel();
    }
}

angular
    .module("nucont.shared")
    .service("DesnuSidenavFormService", [
        "$mdSidenav",
        DesnuSidenavFormService
    ]);
